import _ from 'lodash';
import isObject from '../lang/isObject.js';

// This function mutates object.

// DynamoDb ne supporte pas les strings vide.
// Remplacer les strings vide par la valeur null.

export default function replaceEmptyStringByNullValue(obj) {
  if (!isObject(obj)) return;

  _.forIn(obj, (value, key) => {
    if (isEmptyString(value)) {
      obj[key] = null;
    } else if (_.isArray(value)) {
      _.forEach(value, (item, index) => {
        if (isEmptyString(item)) {
          value[index] = null;
        } else {
          replaceEmptyStringByNullValue(item);
        }
      });
    } else {
      replaceEmptyStringByNullValue(value);
    }
  });

  return obj;
}

const isEmptyString = value => _.isString(value) && value === '';
